export { default as getUpdatedQueryData } from './getUpdatedQueryData';
